if(typeof __WEBPACK_EXTERNAL_MODULE__6900__ === 'undefined') { var e = new Error("Cannot find module 'worker_threads'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = __WEBPACK_EXTERNAL_MODULE__6900__;